

import React, { useState, useEffect } from 'react';
import { BrowserRouter , Routes, Route, Navigate,useNavigate } from "react-router-dom";

import { useTranslation } from 'react-i18next';
import { Container, Row, Col, Button } from 'react-bootstrap';
import './App.css';

import LocalManager from './Infra/LocalManager';

import FunnyErrorPage from './pages/sections/error';
import MainLayout from './pages/MainLayout';
import Dashboard from './pages/dashboard';

import PlantGroups from './pages/sections/PlantGroups';
import GroupPlantsPage from './pages/sections/GroupPlantsPage';
import PlantDetailsPage from './pages/sections/PlantDetailsPage';

import ReminderPage from './pages/ReminderPage';

import MyRemindersPage from './pages/Reminders';

import SearchResultsPage from './pages/sections/PlantSearchResult';
import ProfilePage from './pages/profile';
import SubscriptionPage from './pages/packages';

import PaymentHistory from './pages/payment';

import InvoicePage from './pages/InvoicePage';
import PaymentFailPage from './pages/PaymentFailPage';
import PaymentSuccessPage from './pages/PaymentSuccessPage';

import AdminConsole from './pages/console/dashboard';  
import PlantGroupAdmin from './pages/console/plantGroup';
import PlantAdmin from './pages/console/plant';
import PlansAdmin from './pages/console/plans';
import UserManagement from './pages/console/users';
import DiscountAdmin from './pages/console/discount';
import WateringReminderList from 'scheduler';
import AllPayments from './pages/console/finance'

import { checkUserAccess } from './services/auth/authService';

import { FaAngleLeft } from 'react-icons/fa';


import Login from './pages/login';

function App() {
  const { t, i18n } = useTranslation();

  const changeLanguage = (lng) => {
    i18n.changeLanguage(lng);
  };

  React.useEffect(() => {
    document.documentElement.dir = i18n.language === 'fa' || i18n.language === 'ar' ? 'rtl' : 'ltr';
  }, [i18n.language]);

  useEffect(() => {
    console.log('App version:', process.env.REACT_APP_VERSION);
  }, []);
  

function isLoggedin() {
  let isLoggedIn = LocalManager.getItem('session') ?? false;
  console.warn(isLoggedIn)
  return isLoggedIn;
}

    let [isAuthenticated, setAuthenticated] = useState(isLoggedin());



    const ProtectedRouteAdmin = ({ children }) => {

        const [isAuthorized, setIsAuthorized] = useState(false); 

       useEffect(() => {


         const checkAuth = async () => {
           try {
             const res = await checkUserAccess();
             if (res.ok) {
               setIsAuthorized(true); 
             } else {
               setIsAuthorized(false);
             }
           } catch (err) {
             setIsAuthorized(false);
           }
         };

         checkAuth();
       }, []);


      if (!isAuthenticated || !isAuthorized) {
        return <FunnyErrorPage errorCode={403} errorMessage="You shall not pass!" />;
        // Or use: return <Navigate to="/login" />;
      }
      return children;
    };



      const ProtectedRoutUser  = ({ children }) => {
 

      if (!isAuthenticated) {
        // return <FunnyErrorPage errorCode={403} errorMessage="You shall not pass!" />;
        return <Navigate to="/login" />;
      }
      return children;
    };


    const ConsoleInnerPageWrapper = ({children})=>{
      return (
        <>
          <Row className="">
            <Col xs={2}>
               <a href="/console" className="btn btn-outline-secondary rounded-pill px-3">
              
               {t("common.backConsole")}
              <FaAngleLeft/>

              </a>
            </Col>
          
          </Row>

          {children}


        </>
      )
    };


    const ConsoleRoutes = () => {
      return (
        <Routes>
          <Route path="" element={<AdminConsole />} />
          <Route path="/admin/plant-groups" element={  <PlantGroupAdmin /> } />
          <Route path="/admin/plants" element={ <PlantAdmin /> } />
          <Route path="/admin/plans" element={ <PlansAdmin /> } />
          <Route path="/admin/users" element={ <UserManagement /> } />
          <Route path="/admin/discount" element={ <DiscountAdmin /> } />
          <Route path="/admin/scheduler" element={ <WateringReminderList /> } />
          <Route path="/admin/finance" element={ <AllPayments /> } />


          {/* Add more subroutes here */}
        </Routes>
      );
};


  return (
    <BrowserRouter>
        <Routes>

        {/* <Route path="/login" element={isAuthenticated ? <MainLayout title="Fleet Management - Dashboard"> <DashBoard /> </MainLayout> : <Login />} /> */}
        {/* <Route element={<ProtectedRoute />}> */}



          <Route path="/login" element={<MainLayout showMenu={false} title="Welcome">  <Login/>  </MainLayout>  } />
          <Route path="/logout" element={<MainLayout showMenu={false} title="Welcome Back">  <Login clearSession={true}/>  </MainLayout>  } />
         

          <Route path="/plans" element={<MainLayout title="Welcome">  <SubscriptionPage/> </MainLayout>  } />


          <Route
                path="/"
                element={
                  <ProtectedRoutUser>
                    <MainLayout title="Welcome">  <Dashboard/>  </MainLayout> 
                  </ProtectedRoutUser>
                }/>


         
             {/* <Route path="/" element={<MainLayout title="Welcome">  <Dashboard/>  </MainLayout>  } /> */}


              <Route path="/reminders" element={  <ProtectedRoutUser> <MainLayout title="Welcome">  <MyRemindersPage/> </MainLayout>   </ProtectedRoutUser> } />
              <Route path="/reminders/add/:plantId" element={<ProtectedRoutUser> <MainLayout title="Welcome">  <ReminderPage/> </MainLayout> </ProtectedRoutUser> } />

              <Route path="/reports" element={ <ProtectedRoutUser>   <MainLayout title="Welcome"> REPORTS </MainLayout> </ProtectedRoutUser>  } />


              <Route path="/plants" element={ <ProtectedRoutUser> <MainLayout title="Welcome">  <PlantGroups />  </MainLayout>  </ProtectedRoutUser> } />
              <Route path="/plants/group/:groupId" element={ <ProtectedRoutUser> <MainLayout title="Welcome">  <GroupPlantsPage/> </MainLayout> </ProtectedRoutUser>  } />
              <Route path="/plants/details/:id" element={ <ProtectedRoutUser> <MainLayout title="Welcome">  <PlantDetailsPage/> </MainLayout>  </ProtectedRoutUser> } />

              <Route path="/plants/search/:query" element={ <ProtectedRoutUser> <MainLayout title="Welcome">  <SearchResultsPage/> </MainLayout> </ProtectedRoutUser>  } />

              <Route path="/profile" element={ <ProtectedRoutUser> <MainLayout title="Welcome"> <ProfilePage/> </MainLayout> </ProtectedRoutUser>  } />


              <Route path="/payments" element={ <ProtectedRoutUser> <MainLayout title="Welcome"> <PaymentHistory/> </MainLayout> </ProtectedRoutUser>  } />
              <Route path="/payments/invoice" element={ <ProtectedRoutUser> <MainLayout title="Welcome"> <InvoicePage/> </MainLayout> </ProtectedRoutUser>  } />

              <Route path="/payments/success/:id" element={ <ProtectedRoutUser> <MainLayout title="Welcome"> <PaymentSuccessPage/> </MainLayout> </ProtectedRoutUser>  } />
              <Route path="/payments/failed/:id" element={ <ProtectedRoutUser> <MainLayout title="Welcome"> <PaymentFailPage/> </MainLayout> </ProtectedRoutUser>  } />



         


          <Route
                  path="/console/*"
                  element={
                    <ProtectedRouteAdmin >
                      <MainLayout title="Admin Console">
                        <ConsoleInnerPageWrapper>
                          <ConsoleRoutes />
                        </ConsoleInnerPageWrapper>
                      </MainLayout>
                    </ProtectedRouteAdmin>
                  }
                />
{/* 
         <Route path="/console" element={isAuthenticated ? <MainLayout title="Admin Console"> <AdminConsole /> </MainLayout> 
                  : <FunnyErrorPage errorCode={404} errorMessage="Page Not Found" /> } />
 */}




          {/* <Route path="*" element={<Navigate to="/?not-found=true" />} /> */}
          <Route path="*" element={<FunnyErrorPage errorCode={404} errorMessage="Page Not Found" /> } />


        </Routes>
    </BrowserRouter>


  );

 
}

export default App;
